import { Button, Checkbox } from 'antd'
import PrimaryCheckMark from 'components/PrimaryCheckMark/PrimaryCheckMark'
import React from 'react'

export default function AddressItem(
    {
        lastItem,
        address,
        isChecked,
        onChange,
        isPrimary,
        onPrimaryAddressChange
    }
) {
    return (
        <div style={{
            borderBottom: lastItem ? 0 : '1px solid #e2e4e9',
            paddingBottom: lastItem ? 0 : 8,
            marginBottom: lastItem ? 0 : 8
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 8,

            }}>
                <Checkbox checked={isChecked}
                    onChange={onChange}
                />
                <span style={{
                    fontFamily: 'tradeGothic',
                    display: 'inline-flex',
                    flex: 1
                }}>
                    {address.address}
                </span>
                {
                    isPrimary ? <PrimaryCheckMark /> : <Button
                        onClick={onPrimaryAddressChange}
                        type="text" style={{ padding: 0, height: 'auto' }}>
                        Mark as primary
                    </Button>

                }
            </div>
            {
                address.instructions && <div>
                    <span
                        style={{
                            fontWeight: 600,
                            fontFamily: 'tradeGothic'
                        }}
                    >Instructions:&nbsp;</span>
                    <span style={{
                        fontFamily: 'tradeGothic'
                    }}>
                        {address.instructions}
                    </span>
                </div>
            }
        </div>
    )
}
